export enum QueryKey {
  Transaction = "transaction",
  Authorize = "authorize",
}
